module.exports = __webpack_public_path__ + "img/image-6.fb554553.png";